<template>
  <div>
    <FDBannerImg />
    <div class="navigation">
      <div class="page-cen">
        <div class="navigation-item">
          <a href="javascript:void(0)" @click="goPage('/home')">首页</a
          >&nbsp;&gt;
          <a class="active" href="javascript:void(0)">{{ curMenu?.name }}</a>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="content">
        <div class="content_list" v-if="total > 0">
          <div
            class="list_item"
            v-for="item in dataList"
            :key="item.id"
            @click="toDetail(item)"
          >
            <div>{{ item.title }}</div>
            <div class="keyword" v-if="item.keyword">
              {{ item.keyword }}
            </div>
            <div class="date">{{ item.note }}</div>
          </div>
        </div>
        <Pagination
          v-if="total > 0"
          :total="total"
          :page.sync="currentPage"
          :limit.sync="pageSize"
          @pagination="handleCurrentChange"
        />
        <div v-if="total == 0" class="empty">
          <el-empty description="暂无数据"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import FDBannerImg from "@c/FDBannerImg";

import { post, get } from "@u/request";

export default {
  name: "",
  components: { Pagination, FDBannerImg },
  data() {
    return {
      logo: "",
      copyright: {},
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dataList: [],
      curMenu: {},
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    // 缓存页面name
    catche() {
      return this.$store.getters.includeArr;
    },
    key() {
      return this.$router.fullPath;
    },
  },
  methods: {
    handleCurrentChange() {
      const id = this.id ? parseInt(this.id) : this.id;
      this.loadList(id);
    },
    toDetail(item) {
      if (item.linkUrl) {
        window.open(item.linkUrl);
      } else {
        this.$router.push(`/comPage/comPageDetail/${item.id}/${this.id}`);
      }
    },
    async loadList(id) {
      const params = {
        status: 1,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        menuId: id,
      };
      const { rows, total } = await get("lib/content/list", params).catch(
        () => {}
      );

      this.dataList = rows;
      this.total = total;
    },
    goPage(url) {
      this.$router.push(url);
    },
  },
  created() {
    const id = this.id ? parseInt(this.id) : this.id;
    const menuList = sessionStorage.getItem("menuList")
      ? JSON.parse(sessionStorage.getItem("menuList"))
      : [];
    const curMenu = menuList.find((item) => item.id === id);
    this.curMenu = curMenu;
    this.loadList(id);
  },
};
</script>

<style scoped lang="scss">
.banner_img {
  height: 220px;
  overflow: hidden;
  position: relative;
  img {
    // position:absolute;
    // top: -200px;
    // height: 600;
    // width: 100%;
  }
}
.container {
  width: 1200px;
  margin: 20px auto;
  padding-bottom: 96px;
  min-height: 500px;
  .tag {
    display: flex;
    .tag_item {
      cursor: pointer;
      border: 1px solid #cdcdcd;
      background: #fff;
      font-size: 12px;
      color: #525252;
      line-height: 29px;
      padding: 0 18px;
      margin-right: 10px;
      border-radius: 20px;
    }
    .tag_item:hover,
    .active_tag {
      background-color: #004796;
      color: #fff;
    }
  }
  .content {
    padding-top: 10px;
    .empty {
      text-align: center;
    }
    .content_list {
      margin-bottom: 80px;
      .list_item:hover {
        color: #004796;
      }
      .list_item {
        cursor: pointer;
        position: relative;
        display: flex;
        padding: 20px 0;
        border-bottom: 1px solid #dadada;
        color: #121212;
        .keyword {
          position: absolute;
          right: 100px;
          font-size: 12px;
          border-radius: 30px;
          min-width: 70px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          padding: 0 5px;
          border: 1px solid #cdcdcd;
          background: #fff;
          color: #525252;
        }
        .date {
          position: absolute;
          right: 0;
          color: #999;
          font-size: 14px;
        }
        // .color1 {
        //   background: #eff1ff;
        //   color: #0309b8;
        // }
        // .color2 {
        //   background: #d8ffff;
        //   color: #306eb4;
        // }
        // .color3 {
        //   background: #f6eeff;
        //   color: #82318e;
        // }
        // .color4 {
        //   background: #eee;
        //   color: #878787;
        // }
      }
    }
  }
}
</style>
